import {
  Outlet,
  createFileRoute,
  retainSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';

import { getVoorschriftLabelCollection } from '@/api/collections/labels/voorschrift-label';
import { useLastVigerendBesluit } from '@/api/queries/besluit';

const searchSchema = z.object({
  labelIds: z.array(z.string().uuid()).optional().catch([]),
});

export const Route = createFileRoute('/$bedrijfLineageId/viewer')({
  validateSearch: searchSchema.parse,
  search: {
    middlewares: [retainSearchParams(['labelIds'])],
  },
  beforeLoad: async ({ context, search, params: { bedrijfLineageId } }) => {
    const lastVigerendBesluit = await context.queryClient.ensureQueryData(
      useLastVigerendBesluit.getOptions({ bedrijfLineageId })
    );

    return {
      voorschriftLabelCollection: getVoorschriftLabelCollection({
        besluitLineageId: lastVigerendBesluit.objects?.[0]?.Lineage ?? '',
      }),
      labelIds: search.labelIds ?? [],
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
